import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { TrapActivationHistoryMonitoring } from 'api/traps/types';
import { Breakpoints } from 'hooks/Screen/useScreenSize';

interface HistoryMonitoringColumnProps {
  type: string;
}

export const useGetHistoryMonitoringColumns = ({
  type,
}: HistoryMonitoringColumnProps): TableColumn<TrapActivationHistoryMonitoring>[] => {
  const { t } = useTranslation();

  // smst = snap trap mouse, srst = snap trap rat
  const isSnapTrap = type === 'smst' || type === 'srst';

  // Починаємо з порожнього масиву чітко типізованого
  const columns: TableColumn<TrapActivationHistoryMonitoring>[] = [];

  // 2. crm_date_time — завжди
  columns.push({
    name: t('MCTDetail.TrapHistoryCard.crmDateTime'),
    selector: row => dayjs(row.crm_date_time).format('DD-MM-YYYY\xa0\xa0\xa0HH:mm:ss'),
    sortable: true,
    sortField: 'crm_date_time',
    grow: 2,
  });

  // 3. msg_token
  columns.push({
    name: t('MCTDetail.TrapMonitoringHistoryCard.token'),
    selector: row => row.msg_token,
    hide: Breakpoints.Desktop,
  });

  // 4. rssi
  columns.push({
    name: t('MCTDetail.TrapMonitoringHistoryCard.rrsi'),
    selector: row => row.rssi,
    sortable: true,
    sortField: 'rssi',
    hide: Breakpoints.Desktop,
  });

  // 5. snr
  columns.push({
    name: t('MCTDetail.TrapMonitoringHistoryCard.snr'),
    selector: row => row.snr,
    sortable: true,
    sortField: 'snr',
    hide: Breakpoints.Desktop,
  });

  // 6. battery_percentage
  columns.push({
    name: t('MCTDetail.TrapHistoryCard.battery'),
    selector: row => row.battery_percentage,
    sortable: true,
    sortField: 'battery_percentage',
    hide: Breakpoints.Tablet,
  });

  // 7. caught_pests — теж тільки якщо НЕ snap trap
  if (!isSnapTrap) {
    columns.push({
      name: t('MCTDetail.TrapMonitoringHistoryCard.captures'),
      selector: row => row.caught_pests,
      sortable: true,
      sortField: 'caught_pests',
    });
  }

  return columns;
};
